export const NAVCODE = Object.freeze({
    LEFT: "left",
    FIRST_TOP: "first_top",
    SECOND_TOP: "second_top",
    EXTRA: "extra",
  });

  export const APP_ACTIONS = Object.freeze({
    LOGOUT: "logout",
  })

  export const APP_FORM_ERRORS = Object.freeze({
    FIELD_REQUIRED : "Ce champ est obligatoire.",
    FIELD_NUMBER : "Ce champ doit être un nombre.",
    FIELD_STRING : 'Ce champ doit être de type "String".',
    VALUE_MUST_BE_GREATTER_THAN_ZERO :
      "La valeur de ce champ doit être plus grande que 0.",
    DATE_COMPARISON_ERROR :
      "La date ETA doit être supérieure ou égale à la date ETD",
  });

  export const MODE_LOGIN = Object.freeze({ 
    LOGIN: "login",
    INSCRIPTION: "inscription",
    FORGOT_MDP: "forgot_mdp",
  })

  export const MODE = Object.freeze({ 
    CONSULTATION: "consultation",
    GESTION: "gestion",
  })